import Vue from 'vue'

Vue.filter('price', value => {
  return value ? Math.round(( +value / 100) * Math.pow(10, 2)) / Math.pow(10, 2): 0 ;
})

Vue.filter('intNum', value => {
  value = value.toString()
  const index = value.indexOf('.')
  if(!~index) {
    return value
  }
  return value.substr(0, index)
})

Vue.filter('decimal', value => {

  if(value >= 0) {
    value = value.toString()
    const index = value.indexOf('.')
    if(!~index) return
    return value.substr(index)
  }
  return ''
})

//小数点后恒保留两位小数
Vue.filter('price2', value => {
  let p = value ? Math.round((+value / 100) * Math.pow(10, 2)) / Math.pow(10, 2) : 0;
  let s = p.toString();
  let rs = s.indexOf('.');
  if (value == 0) {
    return '0.00'
  }
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;

})

// 千分位表示
Vue.filter('priceNumFormat', num => {
  var res = num.toString().replace(/\d+/, function (n) { // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      return $1 + ",";
    });
  })
  return res;
})
